import FilePreviewComponent from '@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue';
import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import {
  get_headers,
  get_project_id,
  verify_super_user_status
} from "@/utils/constants/constants.js";

import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import InvoiceSteps from "@/views/probaworkflows_base/invoicing/invoice_steps/InvoiceSteps.vue";
import ComplianceRules from "@/views/probaworkflows_base/management/compliance_management/compliance_rules/ComplianceRules.vue";
import AssignedSubEntities from "@/views/probaworkflows_base/management/entity_management/assigned_sub_entities/AssignedSubEntities.vue";
import EntityTypeAttributes from "@/views/probaworkflows_base/management/entity_management/entity_type_attributes/EntityTypeAttributes.vue";
import WidgetManagement from "@/views/probaworkflows_base/management/entity_management/entity_type_widgets/WidgetManagement.vue";
import CreateForms from "@/views/probaworkflows_base/management/survey_managment/create_forms/CreateForms.vue";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import ManageApprovalRules from "../approval_rules_management/manage_approval_rules/ManageApprovalRules.vue";
import viewEntityTypeCoreMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_core_mixin";
import viewEntityTypeFormsMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_forms_mixin";
import viewEntityTypeTemplatesMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_templates_mixin";
import viewEntityTypeWorkflowsMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_workflows_mixin";
import viewEntityTypeContractsMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_contracts_mixin";


export default {
  name: "ViewEntityType",
  mixins: [
    alert_mixin,
    formatting_mixins,
    viewEntityTypeCoreMixin,
    viewEntityTypeFormsMixin,
    viewEntityTypeTemplatesMixin,
    viewEntityTypeWorkflowsMixin,
    viewEntityTypeContractsMixin,
  ],
  components: {
    GlobalTable,
    ManageApprovalRules,
    CreateForms,
    InvoiceSteps,
    ComplianceRules,
    NavigationBackButton,
    AssignedSubEntities,
    FilePreviewComponent,
    EntityTypeAttributes,
    WidgetManagement,
  },
  data: () => ({
    headers: get_headers(),
    project_id: get_project_id(),
    entity_type_id: sessionStorage.getItem("entity_type_id"),
    entity_type_name: sessionStorage.getItem('entity_type_name'),
    selected_form_id: "",
    active_tab: "Forms",
    tabs: [
      "Fields Required",
      "Forms",
      "Templates",
      "Invoice Steps",
      "Widgets"
      // "Compliance", removed until refactored
      // "Sub-Entities",
    ],
    is_super_user: false,
    email: "",
    form_list: [],
    form_table_headers: [],
    assigned_templates: [],
    loading_templates: false,
    table_safe_form_list: [],
    manage_template: [],
    manage_approval_rules: [],
    manage_invoice_steps: [],
    manage_compliance: [],
    document_url: null,
    form_name: "",
    form_description: "",
    dataTable: null,
    selected_template: {},
    selected_file: "",
    upload_loading: false,
    show_upload_modal: false,
    new_template_name: "",
    upload_from_entity_page: false,
    upload_entity_type_id: null,
    preview_modal: false,
    template_document_entity_type_id: null,
    workflows: [],
    workflows_table_headers: [],
    assigned_workflow: [],
    // Create Advert
    create_advert_data: {
      title: '',
      reference_number: '',
      opening_date: '',
      closing_date: '',
      vacancies: null,
      details: '',
      sections: [],
      display_order: [],
    },
    advert_profile: null,
    advert_loading_profile: false,
    advert_saving: false,
    // View & Edit Advert
    view_advert_data: {},
    edit_advert_data: {
      id: null,
      title: '',
      reference_number: '',
      published_date: '',
      closing_date: '',
      vacancies: null,
      details: '',
      sections: [],
    },
    expanded_templates: [],
    selected_row: {
      id: Number(sessionStorage.getItem("entity_type_id")) || null,
      entity_type: sessionStorage.getItem("entity_type_name") || "",
    },
    selected_advert: null,
    create_advert_open_nonce: 0,
    view_advert_open_nonce: 0,
    edit_advert_open_nonce: 0,
    select_template_id: null,
    modal_template: { id: null, name: "", template_name: "" },
    table_safe_contracts: [],
    contracts_by_template: {}, // Store fetched contracts for each template ID
    loading: false,
  }),
  computed: {
    filtered_data() {
      switch (this.active_tab) {
        case "Forms":
          return this.form_list;
        case "Templates":
          return this.manage_template;
        case "Invoice Steps":
          return this.manage_invoice_steps;
        case "Compliance":
          return this.manage_compliance;
        default:
          return [];
      }
    },
    advert_visible_sections() {
      if (!this.advert_profile?.sections) return [];
      return this.advert_profile.sections.filter(s => s.show_on_advert !== false);
    },
  },
  mounted() {
    this.headers = get_headers();
    this.get_forms();
    const saved_tab = localStorage.getItem("active_tab");
    if (saved_tab && this.tabs.includes(saved_tab)) {
      this.active_tab = saved_tab;
      if (saved_tab === "Templates") {
        this.get_assigned_templates();
        this.view_signing_workflow();
      }
    }
    this.initialize_data_table();

    if (this.$route.query.auto_assign === 'true' && this.$route.query.entity_type_id) {
      this.show_success("Template uploaded and assigned successfully");
      this.get_assigned_templates();
      this.view_signing_workflow();
      this.$router.replace({ query: null });
    }
    this.check_super_user();
  },

  methods: {
    async check_super_user() {
      this.is_super_user = await verify_super_user_status();

      

      if (!this.is_super_user) {
        const super_user_tabs = [
          "Forms",
          "Templates",
          "Invoice Steps",
          "Widgets",
          "Compliance",
          "Sub-Entities",
          "Approval Rules"
        ];

        this.tabs = this.tabs.filter(tab => !super_user_tabs.includes(tab));
      }
    },
  },
};